import "./input.css";

import ReactDOM from "react-dom/client";
import App from "./App";

// create root element
const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <>
    <App />
  </>
);
